module.exports = __webpack_public_path__ + "static/ig_banner_03-4c8cab55113a0580238d69cff5789b5c.png";